import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { groupService } from '../../services/group.service';
import toast from 'react-hot-toast';

interface GroupItemProps {
  group: {
    id: string;
    groupName: string;
    groupCoverImageUrl: string;
    memberCount: number;
  };
  joinedTheGroup: boolean;
  userStatus: string;
  cancelJoin?: (id: string) => void;
}
export const handleCancelJoinGroup = async (groupId: string) => {
  const res = await groupService.cancelJoinGroup(groupId);
  if (res.status === 200) {
    toast.success('đã hủy yêu cầu tham gia nhóm thành công');
  }
};
export const handleJoinGroup = async (groupId: string) => {
  const res = await groupService.joinGroup(groupId, 2, 'test');
  if (res.status === 200) {
    toast.success('đã gửi yêu cầu tham gia nhóm thành công');
  }
};
const GroupItem: React.FC<GroupItemProps> = ({
  group,
  joinedTheGroup,
  userStatus,
  cancelJoin,
}) => {
  const navigator = useNavigate();

  return (
    <div className="flex p-2 rounded-lg border items-center gap-3 border-[#DEE0E6] dark:border-slate-700 ">
      <img
        src={group.groupCoverImageUrl}
        className="2xl:max-w-[120px] max-w-[76px] aspect-square w-full bg-gray-100  rounded-lg object-cover shadow-sm"
        alt="avatar group"
      />

      <div className="flex flex-col flex-1 gap-[6px]">
        <Link
          to={`/group/${group.id}`}
          className="text-sm font-semibold capitalize text-[#111827] dark:text-white"
        >
          {group.groupName}
        </Link>
        <div className="bg-[#EDF0F3] text-[#4A4F63] text-sm  leading-[18px] rounded-[6px] px-2 py-1 flex items-center">
          {group.memberCount} Thành viên <br />0 bài viết/ngày
        </div>
        <button
          type="button"
          className={`button h-10 text-xs dark:text-white gap-1 max-md:hidden ${
            userStatus === 'PENDING'
              ? 'bg-red-200 text-red-500'
              : 'bg-[#0057FF] text-white'
          }`}
          onClick={() => {
            if (joinedTheGroup) {
              navigator(`/group/${group.id}`);
            } else if (!userStatus) {
              handleJoinGroup(group.id);
            } else if (
              userStatus.toLocaleLowerCase() === 'PENDING'.toLocaleLowerCase()
            ) {
              // handleCancelJoinGroup(group.id);
              cancelJoin && cancelJoin(group.id);
            }
          }}
        >
          {joinedTheGroup
            ? 'Xem nhóm'
            : userStatus === 'PENDING'
            ? ' Huỷ yêu cầu'
            : 'tham gia'}
        </button>
      </div>
    </div>
  );
};

export default GroupItem;
